import React, { useState, useEffect, memo } from 'react';
import AxiosServices from '../../services/AxiosServices';
import Singleton from '../../core/singleton';
import events from '../../core/events';
import Loader from '../../ui/Loader';
import Modal from '../../ui/Modal';
import EnableOrDisableOnBoardSales from './forms/EnableOrDisableOnBoardSales';

const OnBoardSales = () => {
    const { getTradByKey, eventEmitter } = Singleton.getInstance();
    const [pending, setPending] = useState(false);
    const [shops, setShops] = useState([]);
    const [manipulatedShop, setManipulatedShop] = useState(null);
    /** get a list of all the shops */
    const getShopsList = () => {
        setPending(true);
        AxiosServices.shops()
            .then(shops => {
                setShops(shops.data);
                setPending(false);
            })
            .catch(error => {
                (error.response.status === 401) &&
                    eventEmitter.emit(events.ON_USER_LOGOUT);
            })
    }
    /** when the form is submited */
    const onFormSubmit = form => form.preventDefault();
    /** when the form is submited */
    const switchShopStatus = shop => setManipulatedShop(shop);
    /** basic use of the modal component */
    const PopUp = () => (manipulatedShop !== null) ? <Modal onClose={() => setManipulatedShop(null)}>
        <EnableOrDisableOnBoardSales shop={manipulatedShop} close={() => {
            setManipulatedShop(null);
            getShopsList();
        }}>
            <p>
                {getTradByKey(`${(manipulatedShop.status === 'open') ? 'disables-on-board-sales' : 'enables-on-board-sales'}`)}
                <br />
                {getTradByKey(`${(manipulatedShop.status === 'open') ? 'passengers_will_not_be_able_to_order' : 'passengers_will_able_to_order'}`)}
            </p>
        </EnableOrDisableOnBoardSales>
    </Modal> : null;

    useEffect(() => getShopsList(), []);

    return <div className="container-fluid">
        <PopUp />
        {
            (pending) &&
            <Loader />
        }
        <h4 className="text-center text-md-right">{getTradByKey('manage_on_board_sales_service')}</h4>
        <form onSubmit={form => onFormSubmit(form)}>
            <ul className="list-group list-group-flush">
                {
                    shops.map((shop, i) => <li key={i} className="list-group-item ">
                        <label className="d-flex justify-content-between align-items-center">
                            {shop.usual_name}
                            <button className="btn btn-primary" onClick={() => switchShopStatus(shop)}>
                                <i className={`fas fa-toggle-${(shop.status === "closed" || shop.status === "display_only") ? 'off' : 'on'}`}></i>
                            </button>
                        </label>
                    </li>)
                }
            </ul>
        </form>
    </div>
}
export default memo(OnBoardSales);